import { __decorate } from "tslib";
import { Pipe } from '@angular/core';
import _ from 'lodash';
let StartCasePipe = class StartCasePipe {
    transform(value) {
        return _.startCase(value);
    }
};
StartCasePipe = __decorate([
    Pipe({
        name: 'startCase'
    })
], StartCasePipe);
export { StartCasePipe };
